import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { connect } from "react-redux";
import { campaignActions } from "../_actions/campaign.actions";
import Paper from "@material-ui/core/Paper";
import ReactHtmlParser from "react-html-parser";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Badge from "@material-ui/core/Badge";
import Chip from "@material-ui/core/Chip";
import { translate } from 'react-i18next';

const styles = theme => ({
  appBar: {
    position: "relative"
  },
  flex: {
    flex: 1
  },
  row: {
    display: "flex",
    justifyContent: "center"
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3
  }),
  paperItem: {
    height: 140,
    width: 100
  },
  bigAvatar: {
    width: 80,
    height: 80
  },
  badgerMargin: {
    margin: theme.spacing.unit * 2
  },
  badgerPadding: {
    padding: `0 ${theme.spacing.unit * 2}px`
  },
  chip: {
    margin: theme.spacing.unit
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class FullScreenDialog extends React.Component {

  handleSignUp = (userId, campId) => event => {
    this.props.dispatch(campaignActions.signUp(userId, campId));
    this.props.dispatch(campaignActions.dialogClose());
  };

  handleClose = () => {
    this.props.dispatch(campaignActions.dialogClose());
  };

  render() {
    const { t, classes,  campaigns, user } = this.props;
    return (
      <div>
        <Dialog
          fullScreen
          open={campaigns.openDialog ? true : false}
          onClose={this.handleClose}
          TransitionComponent={Transition}
        >
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton
                color="inherit"
                onClick={this.handleClose}
                aria-label="Close"
              >
                <CloseIcon />
              </IconButton>
              <Typography
                variant="title"
                color="inherit"
                className={classes.flex}
              >
                {campaigns.item ? campaigns.item.name : "Campaign"}
              </Typography>

              {( user && user.campaignSigned === 0 && campaigns.item && campaigns.item.totalDriver !== campaigns.item.driverSigned)  && <Button color="inherit" onClick={this.handleSignUp(campaigns.userId, campaigns.item.id)}>
                {t("SignUp")}
              </Button>
            }
              
            </Toolbar>
          </AppBar>
          {campaigns.item && (
            <Paper className={classes.paper} elevation={4}>
              <Grid item xs={12}>
                <Grid container spacing={8}>
                  <Grid key="avatar" item>
                    <Avatar
                      alt={campaigns.item.name}
                      src={campaigns.item.image}
                      className={classes.bigAvatar}
                    />
                  </Grid>
                  
                  <Grid key="timeinfo" item>
                    <Typography variant="body2">
                      {t('StartDate')}: {campaigns.item.startDate}
                      <br />
                      {t('EndDate')}: {campaigns.item.endDate}
                      <br />
                      {t('RangeTime')}: {campaigns.item.timeStartRange} {t('UnitHour')} - {" "}
                      {campaigns.item.timeEndRange} {t('UnitHour')}
                      <br />
                      {t('TotalHour')}: {campaigns.item.totalHour} {t('UnitHour')}
                    </Typography>
                  </Grid>

                  <Grid key="totaldriver" item>
                    <Badge
                      color="primary"
                      badgeContent={campaigns.item.totalDriver}
                      className={classes.badgerMargin}
                    >
                      <Typography
                        className={classes.badgerPadding}
                        variant="body2"
                      >
                        {t('TotalDriver')}
                      </Typography>
                    </Badge>

                    <Badge
                      color="secondary"
                      badgeContent={campaigns.item.totalDriver - campaigns.item.driverSigned}
                      className={classes.badgerMargin}
                    >
                      <Typography
                        className={classes.badgerPadding}
                        variant="body2"
                      >
                        {t('RemainDriver')} 
                      </Typography>
                    </Badge>
                  </Grid>
                </Grid>
                <Grid container spacing={8}>
                  <Grid key="tagsarea" item>
                    {campaigns.item.areas && (
                      <div>
                        {campaigns.item.areas.map(area => (
                          <Chip
                            key={area}
                            label={area}
                            className={classes.chip}
                          />
                        ))}
                      </div>
                    )}
                  </Grid>
                </Grid>
                <Grid container spacing={8}>
                  <Grid key="desc" item>
                    <Typography component="p">
                      {ReactHtmlParser(campaigns.item.description)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          )}
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const { authentication, campaigns } = state;
  const {user} = authentication;

  return {
    user,
    campaigns
  };
}


const styleFullScreenDialog = withStyles(styles)(translate('translations')(FullScreenDialog));
const connectedstyleFullScreenDialog = connect(mapStateToProps)(
  styleFullScreenDialog
);

export { connectedstyleFullScreenDialog as FullScreenDialog };



// WEBPACK FOOTER //
// ./src/Dialog/Dialog.js